import { insertNodeAround, isMobile } from '../modules/utilities.js'
import { setAllToMaxHeight } from '../modules/setAllToMaxHeight.js'
import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.core.min.css'
import { attachClampByQuery } from '../modules/clamp.js'
import { SG1Logs } from '../modules/logs.js'

import { h, render } from 'preact'
import { News } from '../../components/news/news.jsx'

export const newsOrchestrator = (data) => {
   try {
      if (data.zones[0].id === 'dom') {
         render(<News {...data.zones[0].data} />, document.getElementById('news'))

         //launch the clamp library on all the elements which need to limit the number of text visible
         document.querySelectorAll('#newsFilInfo [data-clamp-line]').forEach((elmt) => {
            elmt.addEventListener('end.clamp', () => {
               insertNodeAround(elmt, ' - ', "<span class='title-cat mb-0'><strong>", '</strong></span>')
            })
         })

         if (isMobile()) {
            mediaMobileGlideInit()
         } else {
            // NewsFeed
            newsFeedInit(window.newsFeedNumberOfNews, 'desktop')

            // Sliders News
            mediaGlideInit()

            //Totem resize: on adapte la hauteur de fill info en function de la hauteur de totem
            resizeTotem()
         }
      }

      // UNiquement pour le OCCASIONNEL : car y a que l'occas qui envoire un id advise
      if (data.zones[0].id === 'advise') {
         let autopromo = window.dataStoreHP.bandes.news.publicite.autopromoFallback
         if (typeof data.zones[0].data !== 'undefined') {
            const foisonnementData = Object.keys(data.zones[0].data)
               .filter((key) => key.indexOf('foisonnement-b') != -1)
               .map((key) => data.zones[0].data[key])
            if (foisonnementData[0] && foisonnementData[0].length > 0) autopromo = autopromoDataFormatter(foisonnementData)
         }

         let event = new CustomEvent(`newsPublicite`, {
            detail: {
               autopromo: autopromo,
            },
         })
         document.dispatchEvent(event)
      }
   } catch (error) {
      console.error('newsOrchestrator', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.sentryEvent({ error: error, data: data, name: 'News Orchestrator' })
   }
}

export const newsMobileOrchestrator = () => {
   try {
      // Carrousel News
      mediaMobileGlideInit()

      //launch the clamp library on all the elements which need to limit the number of text visible
      document.querySelectorAll('#newsFilInfo [data-clamp-line]').forEach((elmt) => {
         elmt.addEventListener('end.clamp', () => {
            insertNodeAround(elmt, ' - ', "<span class='title-cat mb-0'><strong>", '</strong></span>')
         })
      })
   } catch (error) {
      console.error('newsMobileOrchestrator', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.sentryEvent({ error: error, data: value, name: 'News Mobile Orchestrator' })
   }
}

/**
 * Initialise media slider Glide SMARTPHONE
 */
const mediaMobileGlideInit = () => {
   const slidersMobile = []
   let glideOption = {
      gap: 0,
      animationDuration: 200,
      autoplay: 10000,
   }

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         attachClampByQuery('.o-media-mobile [data-clamp-line]')
         setAllToMaxHeight('.o-media-mobile .js-news-thumb [data-clamp-line]')
      })

      glideSlider.mount()
      slidersMobile.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-sport', 'o-news-media2']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)
      })
   })
   window.mediaSliders = slidersMobile
}

const autopromoDataFormatter = (data) => {
   let autopromo = {}
   try {
      autopromo = data[0][0]
   } catch (error) {
      console.error('autopromoDataFormatter :', error)
      autopromo = {}
   }
   return autopromo
}

/* INIT ONEWS PROSPECT ONLY */
export const initOnewsProspect = () => {
   try {
      //launch the clamp library on all the elements which need to limit the number of text visible
      document.querySelectorAll('#newsFilInfo [data-clamp-line]').forEach((elmt) => {
         elmt.addEventListener('end.clamp', () => {
            insertNodeAround(elmt, ' - ', "<span class='title-cat mb-0'><strong>", '</strong></span>')
         })
      })

      // NewsFeed
      newsFeedInit(window.newsFeedNumberOfNews, 'desktop')

      // Sliders News
      mediaGlideInit()

      //Totem resize: on adapte la hauteur de fill info en function de la hauteur de totem
      resizeTotem()
   } catch (error) {
      console.error('initOnewsProspect', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.sentryEvent({ error: error, name: 'initOnewsProspect' })
   }
}

/**
 * TOTEM
 */
const resizeTotem = () => {
   const checkPubInterval = setInterval(() => {
      const $totemNodes = document.querySelectorAll('#oNews .tag-rm')
      // the totem exist
      $totemNodes.forEach(($totemNode) => {
         // => we can check sizes
         if ($totemNode.getBoundingClientRect().height > 590) {
            document.getElementById('totemColumn').classList.add('totem__big')
            newsFeedUpdate(window.newsFeedNumberOfNews)
            clearInterval(checkPubInterval)
         }
      })

      // the totem doesn't exist
      if ($totemNodes.length === 0) {
         clearInterval(checkPubInterval)
      }
   }, 500)

   // after 40 seconds, the advertising should have been displayed
   // => something is wrong, we stop checking
   setTimeout(() => {
      clearInterval(checkPubInterval)
   }, 40000)
}

/**
 * NEWS FEED
 */
let keyframes = null
let CSSruleIndex = null
let numberOfNews = 0

const newsFeedGenerateKeyframe = function (numberOfNews) {
   const newsHeight = document.querySelector('#newsticker1').offsetHeight
   const animationTime = 0.3
   const animationPause = 4
   const totalTime = (animationTime + animationPause) * numberOfNews
   const animationStepTime = (animationTime / totalTime) * 100
   const pauseStepTime = (animationPause / totalTime) * 100

   let keyframe = '@keyframes ticker {\n'

   let stepAnimation = 0
   let stepPause = 0
   let tickerXPosition = 0

   for (let step = 1; step <= numberOfNews + 1; step++) {
      stepPause = stepAnimation + pauseStepTime

      if (step === numberOfNews + 1) {
         keyframe += stepAnimation.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
         keyframe += stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
         keyframe += '100% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px); animation-timing-function: step-end;}\n'
      } else if (step === 1) {
         keyframe += stepAnimation.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);animation-timing-function: step-start;}\n'
         keyframe += stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
      } else {
         keyframe += stepAnimation.toFixed(2) + '%, ' + stepPause.toFixed(2) + '% { transform: translate3d(0px, ' + tickerXPosition + 'px, 0px);}\n'
      }

      stepAnimation = stepPause + animationStepTime
      tickerXPosition = tickerXPosition - newsHeight
   }
   keyframe += '}'
   return keyframe
}

const newsFeedInsertCSSKeyframes = function (keyframe) {
   if (!keyframes) {
      keyframes = document.createElement('style')
      keyframes.type = 'text/css'
      document.head.appendChild(keyframes)
   }
   CSSruleIndex = keyframes.sheet.insertRule(keyframe, 0)
}

const newsFeedUpdate = function (numberOfNews) {
   let keyframe = newsFeedGenerateKeyframe(numberOfNews)
   keyframes.sheet.deleteRule(CSSruleIndex)
   CSSruleIndex = keyframes.sheet.insertRule(keyframe, 0)
   // Restart animation
   var element = document.getElementById('newsFilInfo')
   element.classList.remove('newsFilInfoAnimate')
   void element.offsetWidth // trigger a DOM reflow
   element.classList.add('newsFilInfoAnimate')
}

export const newsFeedInit = (nbNews, device) => {
   numberOfNews = nbNews
   let keyframe = newsFeedGenerateKeyframe(numberOfNews)
   newsFeedInsertCSSKeyframes(keyframe)
   onResize(document.querySelector('#newsticker1'), () => {
      // if fonts size change, generate a new keyframe and resize
      newsFeedUpdate(window.newsFeedNumberOfNews)
   })
   // resize after init
   if (device === 'desktop') {
      newsFeedUpdate(window.newsFeedNumberOfNews)
   } else {
      // if mobile display 3 news
      resizeContainer(3)
   }

   removeDataClampForAccessibility()
}

// Change the number of slides showed in the news feed slider
const newsFeedResize = (updateNewsFeed) => {
   if (updateNewsFeed) {
      newsFeedUpdate(window.newsFeedNumberOfNews)
   }
}

const onResize = function (element, callback) {
   if (!onResize.watchedElementData) {
      onResize.watchedElementData = []

      var checkForChanges = function () {
         onResize.watchedElementData.forEach(function (data) {
            if (data.element.offsetHeight !== data.offsetHeight) {
               data.offsetHeight = data.element.offsetHeight
               data.callback()
            }
         })
      }

      window.addEventListener('resize', checkForChanges)
      // eslint-disable-next-line no-undef
      var observer = new MutationObserver(checkForChanges)
      observer.observe(document.body, {
         attributes: true,
      })
   }

   onResize.watchedElementData.push({
      element: element,
      offsetHeight: element.offsetHeight,
      callback: callback,
   })
}

// En cas de zoom text, on retire l'elipsis sur le fil info
const removeDataClampForAccessibility = () => {
   let newsItem = document.querySelectorAll('.news-fil-info-title')
   let newsItemWrap = document.querySelectorAll('.news-fil-info-wrap')
   if (newsItem[0] !== undefined && getComputedStyle(newsItem[0]).fontSize !== '16px' && getComputedStyle(newsItem[0]).fontSize !== '14px') {
      newsItem.forEach((item) => {
         item.removeAttribute('style')
         item.removeAttribute('data-clamp-line')
         item.style.overflow = 'visible'
         item.style.height = 'auto'
      })
      newsItemWrap.forEach((item) => {
         item.classList.remove('d-flex')
      })
   }
}

/**
 * CARROUSELS MEDIA DESKTOP
 */
const mediaGlideInit = () => {
   const sliders = []
   let glideOption = {
      gap: 0,
      animationDuration: 0,
      autoplay: 10000,
   }

   var sliderCounter = 0

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         sliderCounter++
         if (sliderCounter === 6) {
            // TODO: setTimeout pour regler un souci due au css critique prospect
            setTimeout(function () {
               attachClampByQuery('.o-media [data-clamp-line]')
               setAllToMaxHeight('.js-news-line0')
               setAllToMaxHeight('.js-news-line1')
               setAllToMaxHeight('.js-news-line2')
               newsFeedResize(true)
            }, 5000)
         }
      })

      glideSlider.mount()
      sliders.push(glideSlider)
      glideSlider.pause()

      glideSlider.selector.onfocus = () => {
         console.log('focus')
      }

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-focus', 'o-news-sport', 'o-news-media2', 'o-news-media3']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)

         // ajout evenements pour accessibilité
         if (glideSlider.selector.classList.contains(sliderName)) {
            document.querySelectorAll('.' + sliderName + ' .onews-reference').forEach((el) => {
               el.addEventListener('focusin', (e) => {
                  glideSlider.pause()
                  e.currentTarget.classList.add('focus-within')
                  let slideIndex = Array.prototype.slice.call(el.parentNode.parentNode.children).indexOf(el.parentNode)
                  glideSlider.go('=' + slideIndex).pause()
               })
               el.addEventListener('focusout', (e) => {
                  e.currentTarget.classList.remove('focus-within')
                  glideSlider.play()
               })
            })
         }
      })
   })
   window.mediaSliders = sliders
}
